import React from "react";
import { t } from "../../../utils/i18n";
import PlaystoreImage from "../../../../assets/images/playstore_image.png";
import AppstoreImage from "../../../../assets/images/appstore_image.png";
import "../../P2PTrades/styles/trademodals.scss";

const DownloadAppModal = ({ onClose }) => {

  return (
    <div
      className="modal-status-cont"
      tabIndex={-1}
      aria-hidden="true"
      id="downloadAppModal"
      aria-labelledby="downloadAppModalLabel"
    >
      <div className="modal-status-alert-cont">
        <div>
          <button type="button" className="close" onClick={onClose} aria-label={t("dashboard.common.close")}>
            <span aria-hidden="true" style={{fontSize: "2.3rem"}}>×</span>
          </button>
          <br />
        </div>

        {/* Modal Title */}
        <div className="modal-title">
          <p style={{ textAlign: "center"}}>
            <i className="fas fa-mobile-alt" style={{ textAlign: "center", fontSize: "2.5rem", color: "#4c3f84" }}></i>
            <br/><br/>
            <span style={{ textAlign: "center", fontSize: "1.7rem", lineHeight: "2rem",  color: "#2b2e4e" }}>{t("dashboard.download_app.title")}</span>
          </p>
        </div>

        {/* Modal Content */}
        <div className="downloadAppModal-notice">
          <p style={{fontSize: "1rem", textAlign: "center"}}>
            {t("dashboard.download_app.notice_1")}
            <br />{t("dashboard.download_app.notice_2")}
          </p>
        </div>
        
        <br/>
        {/* Buttons */}
        <div className="modal-buttons-section">
          <a href="https://play.google.com/store/apps/details?id=com.bananacrystal.BananaCrystal&pli=1" target="_blank" rel="noopener noreferrer">
            <img src={PlaystoreImage} alt="google-play" />
          </a>
          <a href="https://apps.apple.com/tr/app/banana-crystal/id6449340769" target="_blank" rel="noopener noreferrer">
          <img src={AppstoreImage} alt="ios-play" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppModal;
